/** @format */

import { FormGeneralHelper } from './FormGeneral';
import { platformUserActions, platformUserConstants } from '../modules/platformuser/actions';
import { Auth } from '../modules/auth/Auth';
import PlatformUser from '../interfaces/platform/PlatformUser';

const _ = require('underscore');

export class UserRoleHelper {
    static loadUserRole = (): any => {
        const uri = FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_users/' + Auth.getUserId()));
        return platformUserActions.get(
            uri,
            platformUserConstants.ROLE_USER,
            (platformUser: PlatformUser) => {
                if (platformUser.platformUserApiRoles) {
                    Auth.storeRoles(platformUser.platformUserApiRoles);
                }
            },
            { propagateDataToCallback: true }
        );
    };

    static checkRole = (roleName: string, strict = false): boolean => {
        const roles = Auth.getRoles();

        if (!strict) {
            if (_.contains(roles, 'ROLE_SUPERUSER')) {
                return true;
            }
        }

        return _.contains(roles, roleName);
    };
}

export const roles = {
    ROLE_SUPERUSER: 'ROLE_SUPERUSER',
    ROLE_PLATFORMUSER: 'ROLE_PLATFORMUSER',
    ROLE_PRE_CERTIFICATE_GET: 'ROLE_PRE_CERTIFICATE_GET',
    ROLE_PRE_CERTIFICATE_POST: 'ROLE_PRE_CERTIFICATE_POST',

    ROLE_PLATFORM_CLIENT: 'ROLE_PLATFORM_CLIENT',
    ROLE_PLATFORM_CLIENT_GET: 'ROLE_PLATFORM_CLIENT_GET',
    ROLE_PLATFORM_CLIENT_PUT: 'ROLE_PLATFORM_CLIENT_PUT',
    ROLE_PLATFORM_CLIENT_DELETE: 'ROLE_PLATFORM_CLIENT_DELETE',
    ROLE_PLATFORM_CLIENT_POST: 'ROLE_PLATFORM_CLIENT_POST',

    ROLE_PLATFORM_SIMCARD: 'ROLE_PLATFORM_SIMCARD',
    ROLE_PLATFORM_SIMCARD_GET: 'ROLE_PLATFORM_SIMCARD_GET',
    ROLE_PLATFORM_SIMCARD_DELETE: 'ROLE_PLATFORM_SIMCARD_DELETE',
    ROLE_PLATFORM_SIMCARD_POST: 'ROLE_PLATFORM_SIMCARD_POST',

    ROLE_PLATFORM_OPERATION_ON_SIMCARD_ACTIVATE: 'ROLE_PLATFORM_OPERATION_ON_SIMCARD_ACTIVATE',
    ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_TARIFF: 'ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_TARIFF',
    ROLE_PLATFORM_OPERATION_ON_SIMCARD_REMOVE_CONTRACT: 'ROLE_PLATFORM_OPERATION_ON_SIMCARD_REMOVE_CONTRACT',
    ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_VALID_TIME: 'ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_VALID_TIME',
    ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_STATUS: 'ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_STATUS',
    ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_SPN: 'ROLE_PLATFORM_OPERATION_ON_SIMCARD_CHANGE_SPN',

    ROLE_PLATFORM_CHANGE_MSISDN: 'ROLE_PLATFORM_CHANGE_MSISDN',
    ROLE_PLATFORM_CHANGE_ICCID: 'ROLE_PLATFORM_CHANGE_ICCID',
    ROLE_PLATFORM_CHANGE_IP: 'ROLE_PLATFORM_CHANGE_IP',
    ROLE_PLATFORM_CHANGE_GPRS: 'ROLE_PLATFORM_CHANGE_GPRS',
    ROLE_PLATFORM_CHANGE_APN: 'ROLE_PLATFORM_CHANGE_APN',
    ROLE_PLATFORM_CHANGE_TARIFF: 'ROLE_PLATFORM_CHANGE_TARIFF',

    ROLE_PLATFORM_RESELLER: 'ROLE_PLATFORM_RESELLER',
    ROLE_PLATFORM_RESELLER_GET: 'ROLE_PLATFORM_RESELLER_GET',
    ROLE_PLATFORM_RESELLER_PUT: 'ROLE_PLATFORM_RESELLER_PUT',
    ROLE_PLATFORM_RESELLER_DELETE: 'ROLE_PLATFORM_RESELLER_DELETE',
    ROLE_PLATFORM_RESELLER_POST: 'ROLE_PLATFORM_RESELLER_POST',

    ROLE_PLATFORM_ICCID_POOL_NUMBER: 'ROLE_PLATFORM_ICCID_POOL_NUMBER',
    ROLE_PLATFORM_ICCID_POOL_NUMBER_GET: 'ROLE_PLATFORM_ICCID_POOL_NUMBER_GET',
    ROLE_PLATFORM_ICCID_POOL_NUMBER_PUT: 'ROLE_PLATFORM_ICCID_POOL_NUMBER_PUT',
    ROLE_PLATFORM_ICCID_POOL_NUMBER_DELETE: 'ROLE_PLATFORM_ICCID_POOL_NUMBER_DELETE',
    ROLE_PLATFORM_ICCID_POOL_NUMBER_POST: 'ROLE_PLATFORM_ICCID_POOL_NUMBER_POST',
    ROLE_PLATFORM_ICCID_POOL_NUMBER_PARTNER_VIEW: 'ROLE_PLATFORM_ICCID_POOL_NUMBER_PARTNER_VIEW',
    ROLE_PLATFORM_ICCID_RANGE_UPDATE: 'ROLE_PLATFORM_ICCID_RANGE_UPDATE',
    ROLE_PLATFORM_IMSI_POOLS_CHANGE_OWNER_PUT: 'ROLE_PLATFORM_IMSI_POOLS_CHANGE_OWNER_PUT',
    ROLE_QR_CODE_GET: 'ROLE_QR_CODE_GET',

    ROLE_PLATFORM_MSISDN_POOL_NUMBER: 'ROLE_PLATFORM_MSISDN_POOL_NUMBER',
    ROLE_PLATFORM_MSISDN_POOL_NUMBER_GET: 'ROLE_PLATFORM_MSISDN_POOL_NUMBER_GET',
    ROLE_PLATFORM_MSISDN_POOL_NUMBER_PUT: 'ROLE_PLATFORM_MSISDN_POOL_NUMBER_PUT',
    ROLE_PLATFORM_MSISDN_POOL_NUMBER_DELETE: 'ROLE_PLATFORM_MSISDN_POOL_NUMBER_DELETE',
    ROLE_PLATFORM_MSISDN_POOL_NUMBER_POST: 'ROLE_PLATFORM_MSISDN_POOL_NUMBER_POST',
    ROLE_PLATFORM_MSISDN_POOL_NUMBER_PARTNER_VIEW: 'ROLE_PLATFORM_MSISDN_POOL_NUMBER_PARTNER_VIEW',
    ROLE_PLATFORM_MSISDN_RANGE_UPDATE: 'ROLE_PLATFORM_MSISDN_RANGE_UPDATE',
    ROLE_PLATFORM_MSISDN_POOLS_CHANGE_OWNER_PUT: 'ROLE_PLATFORM_MSISDN_POOLS_CHANGE_OWNER_PUT',

    ROLE_PLATFORM_IP_POOL_NUMBER: 'ROLE_PLATFORM_IP_POOL_NUMBER',
    ROLE_PLATFORM_IP_POOL_NUMBER_GET: 'ROLE_PLATFORM_IP_POOL_NUMBER_GET',
    ROLE_PLATFORM_IP_POOL_NUMBER_PUT: 'ROLE_PLATFORM_IP_POOL_NUMBER_PUT',
    ROLE_PLATFORM_IP_POOL_NUMBER_DELETE: 'ROLE_PLATFORM_IP_POOL_NUMBER_DELETE',
    ROLE_PLATFORM_IP_POOL_NUMBER_POST: 'ROLE_PLATFORM_IP_POOL_NUMBER_POST',
    ROLE_PLATFORM_IP_POOL_NUMBER_PARTNER_VIEW: 'ROLE_PLATFORM_IP_POOL_NUMBER_PARTNER_VIEW',
    ROLE_PLATFORM_IP_RANGE_UPDATE: 'ROLE_PLATFORM_IP_RANGE_UPDATE',
    ROLE_PLATFORM_IP_POOLS_CHANGE_OWNER_PUT: 'ROLE_PLATFORM_IP_POOLS_CHANGE_OWNER_PUT',

    ROLE_PLATFORM_PAYMENTS_LIST: 'ROLE_PLATFORM_PAYMENTS_LIST',
    ROLE_PLATFORM_PAYMENTS_LIST_GET: 'ROLE_PLATFORM_PAYMENTS_LIST_GET',

    ROLE_PLATFORM_GET_PNP: 'ROLE_PLATFORM_GET_PNP',
    ROLE_PLATFORM_GET_PNP_GET: 'ROLE_PLATFORM_GET_PNP_GET',
    ROLE_PLATFORM_GET_PNP_POST: 'ROLE_PLATFORM_GET_PNP_POST',

    ROLE_PLATFORM_COMPONENTS_BY_RESELLER: 'ROLE_PLATFORM_COMPONENTS_BY_RESELLER',
    ROLE_PLATFORM_SIMCARD_SERVICE_GET: 'ROLE_PLATFORM_SIMCARD_SERVICE_GET',


    ROLE_PLATFORM_SIMCARD_SERVICE_TYPE_PENDING_DELETE: 'ROLE_PLATFORM_SIMCARD_SERVICE_TYPE_PENDING_PUT',
    ROLE_PLATFORM_SIMCARD_SERVICE_TYPE_PENDING: 'ROLE_PLATFORM_SIMCARD_SERVICE_TYPE_PENDING',

    ROLE_PLATFORM_CLIENT_ADDRESS: 'ROLE_PLATFORM_CLIENT_ADDRESS',
    ROLE_PLATFORM_CLIENT_ADDRESS_GET: 'ROLE_PLATFORM_CLIENT_ADDRESS_GET',
    ROLE_PLATFORM_CLIENT_ADDRESS_PUT: 'ROLE_PLATFORM_CLIENT_ADDRESS_PUT',
    ROLE_PLATFORM_CLIENT_ADDRESS_DELETE: 'ROLE_PLATFORM_CLIENT_ADDRESS_DELETE',
    ROLE_PLATFORM_CLIENT_ADDRESS_POST: 'ROLE_PLATFORM_CLIENT_ADDRESS_POST',

    ROLE_PLATFORM_TARIFF: 'ROLE_PLATFORM_TARIFF',
    ROLE_PLATFORM_TARIFF_GET: 'ROLE_PLATFORM_TARIFF_GET',
    ROLE_PLATFORM_TARIFF_PUT: 'ROLE_PLATFORM_TARIFF_PUT',
    ROLE_PLATFORM_TARIFF_DELETE: 'ROLE_PLATFORM_TARIFF_DELETE',
    ROLE_PLATFORM_TARIFF_POST: 'ROLE_PLATFORM_TARIFF_POST',

    ROLE_PLATFORM_DISCOUNT_TEMPLATE: 'ROLE_PLATFORM_DISCOUNT_TEMPLATE',
    ROLE_PLATFORM_DISCOUNT_TEMPLATE_GET: 'ROLE_PLATFORM_DISCOUNT_TEMPLATE_GET',
    ROLE_PLATFORM_DISCOUNT_TEMPLATE_PUT: 'ROLE_PLATFORM_DISCOUNT_TEMPLATE_PUT',
    ROLE_PLATFORM_DISCOUNT_TEMPLATE_DELETE: 'ROLE_PLATFORM_DISCOUNT_TEMPLATE_DELETE',
    ROLE_PLATFORM_DISCOUNT_TEMPLATE_POST: 'ROLE_PLATFORM_DISCOUNT_TEMPLATE_POST',
    ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE: 'ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE',
    ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE_GET: 'ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE_GET',
    ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE_PUT: 'ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE_PUT',
    ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE_DELETE: 'ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE_DELETE',
    ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE_POST: 'ROLE_PLATFORM_DISCOUNT_TEMPLATES_RATE_POST',

    ROLE_PLATFORM_PROVISIONING: 'ROLE_PLATFORM_PROVISIONING',
    ROLE_PLATFORM_API_OPERATION: 'ROLE_PLATFORM_API_OPERATION',
    ROLE_PLATFORM_PLK_OPERATION: 'ROLE_PLATFORM_PLK_OPERATION',
    ROLE_PLATFORM_PLK_OPERATION_VIEW: 'ROLE_PLATFORM_PLK_OPERATION_VIEW',

    ROLE_PLUS_NOTIFY: 'ROLE_PLUS_NOTIFY',
    ROLE_PLUS_NOTIFY_GET: 'ROLE_PLUS_NOTIFY_GET',
    ROLE_PLUS_NOTIFY_PUT: 'ROLE_PLUS_NOTIFY_PUT',

    ROLE_PLATFORM_MNP: 'ROLE_PLATFORM_MNP',
    ROLE_PLATFORM_RETURN_E14: 'ROLE_PLATFORM_RETURN_E14',
    ROLE_PLATFORM_PORTIN_NUMBER: 'ROLE_PLATFORM_PORTIN_NUMBER',
    ROLE_PLATFORM_PORTOUT_NUMBER: 'ROLE_PLATFORM_PORTOUT_NUMBER',
    ROLE_PLATFORM_ACCEPTANCE_E14: 'ROLE_PLATFORM_ACCEPTANCE_E14',

    ROLE_PLATFORM_APN_ADD_EXTRA_PACKAGE: 'ROLE_PLATFORM_APN_ADD_EXTRA_PACKAGE',
    ROLE_PLATFORM_APN_ADD_EXTRA_PACKAGE_GET: 'ROLE_PLATFORM_APN_ADD_EXTRA_PACKAGE_GET',
    ROLE_PLATFORM_APN_ADD_EXTRA_PACKAGE_POST: 'ROLE_PLATFORM_APN_ADD_EXTRA_PACKAGE_POST',
    ROLE_PLATFORM_APN_ADD_PACKAGE: 'ROLE_PLATFORM_APN_ADD_PACKAGE',
    ROLE_PLATFORM_APN_ADD_PACKAGE_GET: 'ROLE_PLATFORM_APN_ADD_PACKAGE_GET',
    ROLE_PLATFORM_APN_ADD_PACKAGE_POST: 'ROLE_PLATFORM_APN_ADD_PACKAGE_POST',

    ROLE_PLATFORM_APN_DISABLE: 'ROLE_PLATFORM_APN_DISABLE',
    ROLE_PLATFORM_APN_DISABLE_GET: 'ROLE_PLATFORM_APN_DISABLE_GET',
    ROLE_PLATFORM_APN_DISABLE_POST: 'ROLE_PLATFORM_APN_DISABLE_POST',
    ROLE_PLATFORM_APN_DISABLE_PACKAGE: 'ROLE_PLATFORM_APN_DISABLE_PACKAGE',
    ROLE_PLATFORM_APN_DISABLE_PACKAGE_GET: 'ROLE_PLATFORM_APN_DISABLE_PACKAGE_GET',
    ROLE_PLATFORM_APN_DISABLE_PACKAGE_POST: 'ROLE_PLATFORM_APN_DISABLE_PACKAGE_POST',

    ROLE_PLATFORM_APN_ENABLE: 'ROLE_PLATFORM_APN_ENABLE',
    ROLE_PLATFORM_APN_ENABLE_GET: 'ROLE_PLATFORM_APN_ENABLE_GET',
    ROLE_PLATFORM_APN_ENABLE_POST: 'ROLE_PLATFORM_APN_ENABLE_POST',

    ROLE_PLATFORM_MNP_CASE: 'ROLE_PLATFORM_MNP_CASE',
    ROLE_PLATFORM_MNP_CASE_GET: 'ROLE_PLATFORM_MNP_CASE_GET',
    ROLE_PLATFORM_MNP_CASE_POST: 'ROLE_PLATFORM_MNP_CASE_POST',
    ROLE_PLATFORM_MNP_CASE_PUT: 'ROLE_PLATFORM_MNP_CASE_PUT',
    ROLE_PLATFORM_MNP_CASE_DELETE: 'ROLE_PLATFORM_MNP_CASE_DELETE',

    ROLE_PLATFORM_ICCID_RMO_HISTORY: 'ROLE_PLATFORM_ICCID_RMO_HISTORY',
    ROLE_PLATFORM_ICCID_RMO_HISTORY_GET: 'ROLE_PLATFORM_ICCID_RMO_HISTORY_GET',

    /**
     * sim card services
     */
    ROLE_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS: 'ROLE_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS',
    ROLE_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS_GET: 'ROLE_SIM_CARD_SERVICE_TYPE_ALLOWED_PARAMS_GET',

    ROLE_SIM_CARD_SERVICE_TYPE_PARAMS: 'ROLE_SIM_CARD_SERVICE_TYPE_PARAMS',
    ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_GET: 'ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_GET',
    ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_PUT: 'ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_PUT',
    ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_POST: 'ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_POST',
    ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_DELETE: 'ROLE_SIM_CARD_SERVICE_TYPE_PARAMS_DELETE',
    ROLE_SIM_CARD_SERVICE_TYPE_COMPONENT_POST: 'ROLE_SIM_CARD_SERVICE_TYPE_COMPONENT_POST',

    ROLE_SIM_CARD_SERVICE_PARTNER_ALLOWED: 'ROLE_SIM_CARD_SERVICE_PARTNER_ALLOWED',
    ROLE_SIM_CARD_SERVICE_PARTNER_ALLOWED_GET: 'ROLE_SIM_CARD_SERVICE_PARTNER_ALLOWED_GET',
    ROLE_SIM_CARD_SERVICE_PARTNER_ALLOWED_POST: 'ROLE_SIM_CARD_SERVICE_PARTNER_ALLOWED_POST',

    ROLE_SIM_CARD_SERVICE_TYPE_GET: 'ROLE_SIM_CARD_SERVICE_TYPE_GET',
    ROLE_SIM_CARD_SERVICE_TYPE_PUT: 'ROLE_SIM_CARD_SERVICE_TYPE_PUT',
    ROLE_SIM_CARD_SERVICE_TYPE_DELETE: 'ROLE_SIM_CARD_SERVICE_TYPE_DELETE',
    ROLE_SIM_CARD_SERVICE_TYPE_POST: 'ROLE_SIM_CARD_SERVICE_TYPE_POST',

    ROLE_SIM_CARD_SERVICE_TEMPLATE: 'ROLE_SIM_CARD_SERVICE_TEMPLATE',
    ROLE_SIM_CARD_SERVICE_TEMPLATE_GET: 'ROLE_SIM_CARD_SERVICE_TEMPLATE_GET',
    ROLE_SIM_CARD_SERVICE_TEMPLATE_UPDATE: 'ROLE_SIM_CARD_SERVICE_TEMPLATE_UPDATE',
    ROLE_SIM_CARD_SERVICE_TEMPLATE_DELETE: 'ROLE_SIM_CARD_SERVICE_TEMPLATE_DELETE',
    ROLE_SIM_CARD_SERVICE_TEMPLATE_WRITE: 'ROLE_SIM_CARD_SERVICE_TEMPLATE_WRITE',


    ROLE_UPLOAD_SERVICE_LIST: 'ROLE_UPLOAD_SERVICE_LIST',

    ROLE_PLATFORM_PRICELIST: 'ROLE_PLATFORM_PRICELIST',
    ROLE_PLATFORM_PRICELIST_GET: 'ROLE_PLATFORM_PRICELIST_GET',
    ROLE_PLATFORM_PRICELIST_POST: 'ROLE_PLATFORM_PRICELIST_POST',
    ROLE_PLATFORM_PRICELIST_PUT: 'ROLE_PLATFORM_PRICELIST_PUT',
    ROLE_PLATFORM_PRICELIST_DELETE: 'ROLE_PLATFORM_PRICELIST_DELETE',

    ROLE_PLATFORM_PRICELIST_SCHEMA: 'ROLE_PLATFORM_PRICELIST_SCHEMA',
    ROLE_PLATFORM_PRICELIST_SCHEMA_GET: 'ROLE_PLATFORM_PRICELIST_SCHEMA_GET',
    ROLE_PLATFORM_PRICELIST_SCHEMA_POST: 'ROLE_PLATFORM_PRICELIST_SCHEMA_POST',
    ROLE_PLATFORM_PRICELIST_SCHEMA_PUT: 'ROLE_PLATFORM_PRICELIST_SCHEMA_PUT',
    ROLE_PLATFORM_PRICELIST_SCHEMA_DELETE: 'ROLE_PLATFORM_PRICELIST_SCHEMA_DELETE',

    ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT: 'ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT',
    ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT_GET: 'ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT_GET',
    ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT_POST: 'ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT_POST',
    ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT_PUT: 'ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT_PUT',
    ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT_DELETE: 'ROLE_PLATFORM_PRICELIST_SCHEMA_ELEMENT_DELETE',

    ROLE_MNO_MESSAGE_GET: 'ROLE_MNO_MESSAGE_GET',
    ROLE_MNO_MESSAGE: 'ROLE_MNO_MESSAGE',

    ROLE_UPLOAD_MSISDN_POOLS: 'ROLE_UPLOAD_MSISDN_POOLS',
    ROLE_UPLOAD_ICCID_POOLS: 'ROLE_UPLOAD_ICCID_POOLS',
    ROLE_UPLOAD_IP_POOLS: 'ROLE_UPLOAD_IP_POOLS',
    ROLE_PLATFORM_POOLS_FILE: 'ROLE_PLATFORM_POOLS_FILE',
    ROLE_PLATFORM_POOLS_FILE_GET: 'ROLE_PLATFORM_POOLS_FILE_GET',
    ROLE_PLATFORM_POOLS_FILE_MSISDN_PUT: 'ROLE_PLATFORM_POOLS_FILE_MSISDN_PUT',
    ROLE_PLATFORM_POOLS_FILE_IMSI_PUT: 'ROLE_PLATFORM_POOLS_FILE_IMSI_PUT',
    ROLE_PLATFORM_POOLS_FILE_IP_PUT: 'ROLE_PLATFORM_POOLS_FILE_IP_PUT',

    /** MENU ROLES */
    ROLE_MENU_POOL_MANAGE: 'ROLE_MENU_POOL_MANAGE',

    ROLE_PLATFORM_USER_ACCOUNT_ADMIN: 'ROLE_PLATFORM_USER_ACCOUNT_ADMIN',

    ROLE_MSISDN_PLATFORM_POOL_NUMBER_PARTNER_VIEW: 'ROLE_MSISDN_PLATFORM_POOL_NUMBER_PARTNER_VIEW',
    ROLE_ICCID_PLATFORM_POOL_NUMBER_PARTNER_VIEW: 'ROLE_ICCID_PLATFORM_POOL_NUMBER_PARTNER_VIEW',
    ROLE_IP_PLATFORM_POOL_NUMBER_PARTNER_VIEW: 'ROLE_IP_PLATFORM_POOL_NUMBER_PARTNER_VIEW',

    /** BLOCK **/
    ROLE_PLATFORM_BLOCK_CONTAINS: 'ROLE_PLATFORM_BLOCK_CONTAINS',
    ROLE_PLATFORM_BLOCK_CONTAINS_GET: 'ROLE_PLATFORM_BLOCK_CONTAINS_GET',
    ROLE_PLATFORM_BLOCK_CONTAINS_PUT: 'ROLE_PLATFORM_BLOCK_CONTAINS_PUT',
    ROLE_PLATFORM_BLOCK_CONTAINS_POST: 'ROLE_PLATFORM_BLOCK_CONTAINS_POST',
    ROLE_PLATFORM_BLOCK_CONTAINS_DELETE: 'ROLE_PLATFORM_BLOCK_CONTAINS_DELETE',

    ROLE_BLOCK_OPERATION_ON_SERVICES_GET: 'ROLE_BLOCK_OPERATION_ON_SERVICES_GET',
    ROLE_BLOCK_OPERATION_ON_SERVICES_POST: 'ROLE_BLOCK_OPERATION_ON_SERVICES_POST',

    ROLE_BLOCK_OPERATION_SYNCHRONIZE_GET: 'ROLE_BLOCK_OPERATION_SYNCHRONIZE_GET',
    ROLE_BLOCK_OPERATION_SYNCHRONIZE_POST: 'ROLE_BLOCK_OPERATION_SYNCHRONIZE_POST',

    ROLE_BLOCK_OPERATION_ON_BLOCK: 'ROLE_BLOCK_OPERATION_ON_BLOCK',
    ROLE_BLOCK_OPERATION_ON_BLOCK_CHANGE_PARAMS: 'ROLE_BLOCK_OPERATION_ON_BLOCK_CHANGE_PARAMS',

    /** DISCOUNT **/
    ROLE_PLATFORM_DISCOUNT_GET: 'ROLE_PLATFORM_DISCOUNT_GET',
    ROLE_PLATFORM_DISCOUNT_POST: 'ROLE_PLATFORM_DISCOUNT_POST',
    ROLE_PLATFORM_DISCOUNT_PUT: 'ROLE_PLATFORM_DISCOUNT_PUT',
    ROLE_PLATFORM_DISCOUNT_DELETE: 'ROLE_PLATFORM_DISCOUNT_DELETE',

    /** PREFIX **/

    ROLE_PLATFORM_PREFIX_POST: 'ROLE_PLATFORM_PREFIX_POST',
    ROLE_PLATFORM_PREFIX_PUT: 'ROLE_PLATFORM_PREFIX_PUT',
    ROLE_PLATFORM_PREFIX_DELETE: 'ROLE_PLATFORM_PREFIX_DELETE',

    /** FRACTION **/
    ROLE_PLATFORM_FRACTION_DELETE: 'ROLE_PLATFORM_FRACTION_DELETE',

    /** PACKAGE GROUPS  **/
    ROLE_SIM_CARD_VIRTUAL_COMPONENT_UPDATE: 'ROLE_SIM_CARD_VIRTUAL_COMPONENT_UPDATE',
    ROLE_SIM_CARD_VIRTUAL_COMPONENT_WRITE: 'ROLE_SIM_CARD_VIRTUAL_COMPONENT_WRITE',

    /** ONLY VISIBLE ROLES **/
    ROLE_SUBSCRIPTION_VIEW_ONLY: 'ROLE_SUBSCRIPTION_VIEW_ONLY',

    /** SERVICES ACTIVATION **/
    ROLE_PLATFORM_USSD_SMS_COMMUNICATION_POST: 'ROLE_PLATFORM_USSD_SMS_COMMUNICATION_POST',
    ROLE_PLATFORM_USSD_SMS_COMMUNICATION_PUT: 'ROLE_PLATFORM_USSD_SMS_COMMUNICATION_PUT',

    ROLE_PLATFORM_MSISDN_MNO_HISTORY: 'ROLE_PLATFORM_MSISDN_MNO_HISTORY',
    ROLE_PLATFORM_MSISDN_MNO_OPERATION: 'ROLE_PLATFORM_MSISDN_MNO_OPERATION',

    /** Linear Billing **/
    ROLE_UPLOAD_LINEAR_BILLING: 'ROLE_UPLOAD_LINEAR_BILLING', //import cennikow
    ROLE_PLATFORM_CUSTOM_BILLING_ACTION_POST: 'ROLE_PLATFORM_CUSTOM_BILLING_ACTION_POST', //zarzadzanie cennikami
    ROLE_PLATFORM_CUSTOM_BILLING_ACTION_PRICELIST_REMOVE: 'ROLE_PLATFORM_CUSTOM_BILLING_ACTION_PRICELIST_REMOVE', //usuwanie cennikow recznie/z importu
    ROLE_PLATFORM_CUSTOM_BILLING_ACTION_HISTORICAL_EDIT: 'ROLE_PLATFORM_CUSTOM_BILLING_ACTION_HISTORICAL_EDIT', //edycja historii cennikow
};
